module.exports = __webpack_public_path__ + "img/living_room_thumb.871095fc.jpg";